export default __webpack_public_path__ + "0993de43344d0d96c24ecb8e707cb5ed.png";